<template>
  <div class="apply_box">
    <div class="notice">请保持银行卡号、身份证、预留手机号一致</div>
    <!-- <div class="bg"></div> -->
    <div class="pro_detail"
         v-for="(item, index) in bankList"
         :key="index">
      <!-- <div class="pro_item"
           v-if="index == 0">
        <h1 class="h1"><span class="line"></span> 身份信息 </h1>
      </div>
      <div class="pro_item"
           v-if="index == 2">
        <h1 class="h1"><span class="line"></span> 银行卡信息 </h1>
      </div> -->
      <div class="pro_item1"
           :class="{ padding9: index == 0 }">
        <span class="label">{{ item.title }}</span>
        <input type="text"
               :placeholder="item.placeholder"
               class="inputStyle1"
               :class="{ inputStyle: item.type == 3, color99: item.type == 1 }"
               v-model="item.value"
               :readOnly="item.readOnly" />
        <span v-if="!cutStart && item.type == 3"
              class="replace_btn right"
              @click="getMsgCode">获取验证码</span>
        <span v-if="cutStart && item.type == 3"
              class="replace_btn right cc">剩余{{ second }}s</span>
      </div>
      <!-- <div class="bg"
           v-if="index==1"></div> -->
    </div>
    <div class="info_box"
         v-if="loanPlatformJson.title1">
      <div class="xy_box">
        <span class="icon_circle"
              :class="{ icon_circleAct: isActive }"
              @click="checkStatus()"></span>
        {{ loanPlatformJson.title1 }}
        <span class="agree"
              @click="toSuportBank(loanPlatformJson.pageUrl)">{{
          loanPlatformJson.title2
        }}</span>
      </div>
    </div>
    <div class="info_box"
         v-show="product == 1">
      <span class="icon_circle"
            :class="{ icon_circleAct: isActive }"
            @click="checkStatus()"></span>
      本人已阅读并同意
      <span class="agree"
            @click="toPage(1)">《百行征信授权书》</span>、<span class="agree"
            @click="toPage(2)">《个人信息使用授权书》</span>、<span class="agree"
            @click="toPage(3)">《个人征信业务授权书》</span>
    </div>
    <div class="loan_btn"
         @click="bindBank">确认</div>

    <div class="info"
         v-show="isOriginHei">
      <!-- <p><img class="bank_icon"
             src="../../assets/img/afterLoan/bank_icon.png"
             alt="">
        请保证银行卡号、身份证号、预留手机号一致</p> -->
      <p class="bank_list"
         v-if="supportCardList && supportCardList.type == 1"
         @click="toSuportBank(supportCardList.pageUrl)">
        {{ supportCardList.title }}
      </p>
      <p class="bank_list tl"
         v-if="supportCardList && supportCardList.type == 2">
        {{ supportCardList.title }}
        <span class="bank_font"
              v-for="(itm, idx) in supportCardList.cardList"
              :key="idx">{{ itm }}
          <span v-if="idx !== supportCardList.cardList.length - 1">、</span></span>
      </p>
    </div>
    <!-- <div class="help">
      <a href="javascript.void(0)">绑卡失败，咨询客服</a>
    </div> -->

    <agreeToast :propJson="agreeJson"
                @pageUrl="pageUrl" />

    <Loading :isShow="isShowLoading"></Loading>
  </div>
</template>

<script>
import agreeToast from "@/components/agreeToast";
import Loading from "@/components/loading";
export default {
  components: {
    agreeToast,
    Loading
  },
  data () {
    return {
      isShowLoading: false,
      agreeJson: {
        isShow: false,
        title: "征信授权协议",
        info: `个人征信业务授权书
【特别提醒】：
为了保障您的合法权益，在您确认签署《个人征信业务授权书》之前，请您务必仔细阅读《个人征信业务授权书》的所有条款，充分理解条款内容，并严格遵守《个人征信业务授权书》。《个人征信业务授权书》以数据电文形式订立，一旦您在线确认个人征信业务授权书，即视为您已充分理解《个人征信业务授权书》所有条款的含义及相应的法律后果，并同意接受所有授权书条款的约束。
《个人征信业务授权书》是您向被授权人做出的单方授权，效力具有独立性，不因《个人消费贷款合同》或其他文件任何条款的无效而无效。即使您的贷款申请未被审核通过，《个人征信业务授权书》各项授权的有效性不受影响。
晋商消费金融股份有限公司：
本人特授权贵司在办理下列业务过程中（从业务申请至业务终止），可以通过中国人民银行个人信用信息基础数据库查询、使用、保存本人的信用报告，并同意将本人的身份识别、职业和居住地址等个人基本信息，本人在个人贷款、各类信用卡和对外担保等信用活动中形成的交易记录等个人信贷交易信息及其他相关信息向中国人民银行个人信用信息基础数据库报送：
    （1）审核贷款申请；
    （2）审核本人作为担保人；
    （3）对已发放的个人信贷进行贷后风险管理；
    （4）受理法人或其他组织作为贷款担保人，需要查询其法定代表人及出资人信用状况；
（5）特约商户实名审查；
（6）法定代表人、负责人、高管等资信审查；
（7）客户准入资格审查；
（8）异议核查；
（9）其他贵司认为需要本人信用状况的合法合规的业务。
若本人与贵司发生任何纠纷或争议，首先应友好协商解决。协商不成的，本人同意将纠纷或争议提交贵司注册地有管辖权的人民法院管辖。本授权书的成立、生效、履行、解释及纠纷解决，适用中华人民共和国大陆地区法律（不包括冲突法）。
本人声明：本人已仔细阅读上述所有条款，并已特别注意字体加黑的内容。贵司已应本人要求对相关条款予以明确说明。本人对所有条款的含义及相应的法律后果已全部通晓并充分理解，本人自愿作出上述授权、承诺和声明。

授权人（签章）：
身份证号码：  
授权日期：`,
        btn: "阅读并同意"
      },
      second: 59,
      cutStart: false,
      productId: "",
      name: "",
      bankCardId: "",
      phone: "",
      veifyCode: "",
      bankList: [],
      bankInfo: [],
      realName: "",
      isActive: false,
      supportCardList: {},
      loanPlatformJson: {},
      userList: [],
      isOriginHei: true, //显示或者隐藏button
      documentHeight: document.documentElement.clientHeight, //默认屏幕高度
      product: ""
    };
  },
  mounted () {
    this.orderId = this.$route.query.orderId;
    this.util.title("绑定银行卡");
    this.getBankList();
    // window.onresize监听页面高度的变化
    window.onresize = () => {
      return (() => {
        if (this.documentHeight > document.documentElement.clientHeight) {
          this.isOriginHei = false;
        } else {
          this.isOriginHei = true;
        }
      })();
    };
  },
  methods: {
    toPage (page) {
      if (page == 1) {
        //《百行征信授权书》
        window.location.href =
          "http://thread.yanhugame.com/agreement%2F%E7%99%BE%E8%A1%8C%E4%B8%AA%E4%BA%BA%E5%BE%81%E4%BF%A1%E6%8E%88%E6%9D%83%E4%B9%A6.pdf";
      } else if (page == 2) {
        //《个人信息使用授权书》
        window.location.href =
          "http://thread.yanhugame.com/agreement%2F%E4%B8%AA%E4%BA%BA%E4%BF%A1%E6%81%AF%E4%BD%BF%E7%94%A8%E6%8E%88%E6%9D%83%E4%B9%A6.pdf";
      } else if (page == 3) {
        //《个人征信业务授权书》
        window.location.href =
          "http://thread.yanhugame.com/agreement%2F%E4%B8%AA%E4%BA%BA%E5%BE%81%E4%BF%A1%E4%B8%9A%E5%8A%A1%E6%8E%88%E6%9D%83%E4%B9%A6.pdf";
      }
    },
    pageUrl () {
      this.isActive = true;
      this.toAuthCredit(); //去征信授权
      this.agreeJson.isShow = false;
    },
    checkStatus () {
      this.isActive = !this.isActive;
    },
    toAuthCredit () {
      let _this = this;
      this.$get("/app/api/v1/order/authCredit/" + this.orderId, {})
        .then(res => {
          var e = res;
          if (e.code == 200) {
            _this.util.toast({ msg: e.data ? e.data : "征信授权成功" });
          } else {
            _this.util.toast({ msg: e.message });
          }
        })
        .catch(error => { });
    },
    toSuportBank (pageUrl) {
      // this.$router.push({
      //   path: '/afterLoan/suportBank',
      //   query: {
      //   }
      // });
      window.location.href = pageUrl;
    },
    getBankList () {
      let _this = this;
      this.$get("/app/api/v1/order/bankcard/info/" + this.orderId, {})
        .then(res => {
          var e = res;
          if (e.code == 200) {
            let data = e.data.content;
            if (e.data.product == 1) {
              _this.agreeJson.isShow = e.data.product; //1：如期产品，2：易美付（普通产品）
            }
            _this.product = e.data.product;
            _this.supportCardList = e.data.supportCardList;
            _this.realName = e.data.realName;
            let arr = [];
            _this.loanPlatformJson = e.data.loanPlatform;
            e.data.content.map(function (item) {
              return arr.concat(item.sub);
            });
            data.map(function (item) {
              item.sub.map(function (itm) {
                if (itm.type != 4) {
                  if (itm.type == 1) {
                    // itm.value = e.data.realName;
                    itm.readOnly = "readOnly";
                  }
                  return _this.bankList.push(itm);
                }
              });
            });
            let arr1 = [];
            _this.bankList.map(function (item) {
              return _this.bankInfo.push(item.key);
            });
          } else {
            _this.util.toast({ msg: e.message });
          }
        })
        .catch(error => { });
    },
    getMsgCode () {
      //获取验证码
      let _this = this;
      let param = {
        orderId: _this.orderId
      };
      let yzmList = [];
      this.bankList.map(function (item, index) {
        if (item.type == 2 || item.type == 1) {
          yzmList.push(item);
        }
      });
      let len = yzmList.length;
      yzmList.map(function (item, index) {
        if (item.value == "" || item.value == undefined || item.value == null) {
          _this.util.toast({ msg: item.placeholder });
          return false;
        } else {
          --len;
          return (param[item.key] = item.value);
        }
      });
      if (len > 0) {
        return false;
      }
      this.$post("/app/api/v1/order/bankcard/bind", param).then(res => {
        if (res.code == 200) {
          this.cutdown();
        } else if (res.code == 201) {
          //不需要验证码
          this.util.toast({ msg: res.message });
          _this.isShowLoading = true;
          setTimeout(() => {
            _this.isShowLoading = false;
            window.location.href = res.data;
          }, 2000);
          // setTimeout(() => {
          //   window.location.href = res.data;
          // }, 2000)
        } else {
          this.util.toast({ msg: res.message, type: "fail" });
        }
      });
    },
    cutdown () {
      //倒计时
      this.cutStart = true;
      if (this.second == 0) {
        this.cutStart = false;
        this.second = 59;
        return;
      } else {
        this.second = this.second - 1;
        setTimeout(() => {
          this.cutdown();
        }, 1000);
      }
    },
    bindBank () {
      //绑定银行卡
      let _this = this;
      let param = {};
      let len = this.bankList.length;
      param = {
        orderId: this.orderId
      };
      this.bankList.map(function (item, index) {
        if (item.value == "" || item.value == undefined || item.value == null) {
          _this.util.toast({ msg: item.placeholder });
          return false;
        } else {
          --len;
          return (param[item.key] = item.value);
        }
      });
      if (len > 0) {
        return false;
      }
      if (_this.loanPlatformJson.title2 && !_this.isActive) {
        _this.util.toast({ msg: "请先勾选协议" });
        return false;
      }
      _this.isShowLoading = true;
      this.$post("/app/api/v1/order/bankcard/bind", param)
        .then(res => {
          var e = res;
          if (e.code == 200) {
            _this.util.toast({ msg: "绑卡成功" });
            if (_this.product == 1 || _this.product == 2) {
              // 如期——1(控制跳转页面+征信协议)
              // 易美付、桔子分期——2产品(控制跳转的页面)
              setTimeout(() => {
                _this.isShowLoading = false;
                //去状态页面
                this.$router.push({
                  path: "/loan/applyDetail",
                  query: {
                    orderId: _this.orderId
                  }
                });
              }, 30000);
            } else {
              //回到签约页面
              this.$router.push({
                path: "/loan/loanMoney",
                query: {
                  orderId: _this.orderId
                }
              });
            }
          } else {
            _this.isShowLoading = false;
            _this.util.toast({ msg: e.message });
          }
        })
        .catch(error => { });
    }
  }
};
</script>
<style scoped>
html {
  font-size: 62.5%;
}
.notice {
  padding: 0.12rem 0 0.1rem 0;
  font-size: 0.14rem;
  color: #5983fc;
  background: #e6ebff;
  text-align: center;
}
.padding9 {
  padding-top: 0.09rem;
}
.apply_box {
  background: #f7f7f7;
  font-size: 0.24rem;
}
.pro_detail {
  background: #ffffff;
}
.bg {
  background: #f7f7f7;
  width: 100%;
  height: 0.1rem;
}
.pro_item {
  padding: 0.15rem;
  border-bottom: 1px solid #eee;
  display: flex;
  flex: 1;
  justify-content: space-between;
}

.replace_btn {
  color: #486cff;
  font-size: 0.14rem;
  padding: 0.15rem;
  padding: 0.15rem 0;
}

.pro_item1 {
  clear: both;
  overflow: hidden;
  border-bottom: 1px solid #f5f5f5;
  margin: 0 0.15rem;
}
.label {
  font-size: 0.14rem;
  color: #666;
  display: inline-block;
  width: 0.75rem;
}
.inputStyle,
.inputStyle1 {
  padding: 0.15rem;
  color: #333;
  font-size: 0.14rem;
  width: 74%;
  font-family: PingFangSC-Regular;
  font-weight: 400;
}
.color99 {
  color: #999;
}
.inputStyle {
  width: 50%;
}
.h1 {
  font-family: PingFangSC-Medium;
  font-weight: 500;
  font-size: 0.14rem;
  color: #333;
}
.line {
  display: inline-block;
  width: 3px;
  height: 0.12rem;
  background: #486cff;
}
.loan_btn {
  color: #fff;
  background: linear-gradient(
    90deg,
    rgba(122, 157, 246, 1) 0%,
    rgba(81, 117, 241, 1) 100%
  );
  box-shadow: 0px 6px 10px 0px rgba(228, 238, 250, 1);
  border-radius: 25px;
  height: 0.5rem;
  line-height: 0.5rem;
  font-size: 0.17rem;
  text-align: center;
  line-height: 0.5rem;
  width: 90%;
  margin: 0 auto;
  margin-top: 0.22rem;
}
.info {
  padding: 0 0.15rem;
  color: #333;
  font-size: 0.11rem;
  text-align: center;
  width: 100%;
  padding-top: 0.08rem;
}
.info p {
  font-size: 0.12rem;
  color: #999;
  text-align: center;
}
.bank_list {
  color: #486cff;
  margin-top: 0.2rem;
  display: inline-block;
  /* padding-left: 0.25rem; */
}
.bank_font {
  color: #333;
  font-weight: 500;
}
.info .tl {
  text-align: left;
}
.bank_icon {
  display: inline-block;
  width: 0.16rem;
  height: 0.1rem;
  margin-right: 0.05rem;
}
.help {
  width: 100%;
  position: fixed;
  bottom: 0.2rem;
  left: 0;
  color: #999;
  font-size: 0.11rem;
  text-align: center;
}
.cc {
  color: #ccc;
}
.info_box {
  font-size: 0.11rem;
  color: #333;
  padding: 0.1rem 0.15rem 0 0.15rem;
  background: #f7f7f7;
}
.info_box .agree {
  color: #486cff;
}
.icon_circle,
.icon_circleAct {
  position: relative;
  top: 0.024rem;
  margin-right: 0.05rem;
  display: inline-block;
  width: 0.14rem;
  height: 0.14rem;
  background: url('../../assets/img/afterLoan/choice_unCheck.png') no-repeat top
    center;
  background-size: 100% 100%;
}
.icon_circleAct {
  background: url('../../assets/img/afterLoan/checked.png') no-repeat top center;
  background-size: 100% 100%;
}

.pay_btn_succ {
  background: linear-gradient(
    90deg,
    rgba(122, 157, 246, 0.8) 0%,
    rgba(81, 117, 241, 1) 100%
  );
}
</style>
